/** PC/WAP 底部导航中的协议列表模板，使用模块外层 template_id。 */
export const LEGAL_LINKS_TEMPLATE_ID = 2;

interface FooterLegalModule {
  id?: number;
  template_id?: number;
  content?: unknown;
}

interface FooterLegalLinkBase {
  key: string;
  label: string;
  firstLevelTitle: string;
  firstLevelIndex: number;
  secondLevelIndex: number;
}

export type FooterLegalLink = FooterLegalLinkBase &
  ({ jump: 'popup' } | { jump: 'link' | undefined; href: string });

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** 按接口顺序展开协议模块；后台未配置或条目不完整时不补前端默认项。 */
export function getFooterLegalLinks(navList: readonly FooterLegalModule[]): FooterLegalLink[] {
  return navList.flatMap((module, moduleIndex) => {
    if (module.template_id !== LEGAL_LINKS_TEMPLATE_ID || !isRecord(module.content)) return [];
    const list: unknown = module.content.list;
    if (!Array.isArray(list)) return [];
    const firstLevelTitle =
      typeof module.content.layout_title === 'string'
        ? module.content.layout_title
        : typeof module.content.template_title === 'string'
          ? module.content.template_title
          : '';

    return list.flatMap((item: unknown, itemIndex): FooterLegalLink[] => {
      if (!isRecord(item) || typeof item.title !== 'string') {
        return [];
      }
      const label = item.title.trim();
      if (!label) return [];

      const base: FooterLegalLinkBase = {
        key: `${module.id ?? moduleIndex}:${itemIndex}`,
        label,
        firstLevelTitle,
        firstLevelIndex: moduleIndex,
        secondLevelIndex: itemIndex,
      };
      // 弹窗没有链接地址；以跳转类型为准，即使后台残留 href 也不导航。
      if (item.jump === 'popup') return [{ ...base, jump: 'popup' }];
      if (item.jump != null && item.jump !== 'link') return [];
      const href = typeof item.href === 'string' ? item.href.trim() : '';
      if (!href) return [];

      return [{ ...base, jump: item.jump === 'link' ? 'link' : undefined, href }];
    });
  });
}
